import { TableComponent } from "../../components/common/table/table.component";
import { CommonModule } from "@angular/common";
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { TitleTextPipe } from "../../custom.pipe";
import { ToastrService } from "ngx-toastr";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ApiService } from "../../api.service";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MessageComponent } from "../../components/common/message/message.component";

@Component({
  selector: 'app-final-page-n2p',
  standalone: true,
  imports: [TableComponent,MessageComponent,CommonModule,
      NgxSpinnerModule, TitleTextPipe],
  templateUrl: './final-page-n2p.component.html',
  styleUrl: './final-page-n2p.component.css'
})
export class FinalPageN2pComponent implements OnInit{
  @Input() inputData: any;
    isLoading: boolean = false;
    tableData: any;
    showMessage: boolean = false;
    MessageToShow: any;
    showADRCard:boolean=false;
    final_screen:boolean=true;
    url: string = '';
    filename: string = '';
    msg: string = ''; 
    selectedRow: any;
    myAdrForm!: FormGroup;
    file: string | null = null;
    
    constructor(private toastr: ToastrService,
      private fb: FormBuilder,
      private apiService: ApiService,
      private spinner: NgxSpinnerService) { 
  
    }

    ngOnInit() {

  }

  receiveTableEventFinalCall(){
    this.isLoading = true;
      this.spinner.show()  
      this.apiService.generateN2pOutput(this.inputData).subscribe({
      next: (response) => {
                if (response.message == 'Pre-signed url has been generated') {
                  this.showMessage = true; 
                  this.MessageToShow = JSON.stringify(response);
                }
                else if (response.message == 'upload adr') {
                  this.showADRCard = true;
                  this.final_screen = false;
                  this.inputData = response;
                }
                
                else {              
                  if ('file_name' in response) {
                    this.final_screen = false;
                    this.showMessage = true;
                    this.MessageToShow = response;
                  } else {
                    this.toastr.error(response.message, 'Error Message');
                    console.log('error');
                  }
                }

            this.isLoading = false;
            this.spinner.hide();
      },
      error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
          },
    });
  }

  table_function_called() {
    this.isLoading = true;
    this.spinner.show();
    if (this.selectedRow && this.selectedRow.length > 0) {
      let new_route_list = [];
      for (let ele of this.selectedRow) {
        new_route_list.push(ele['Paths']);
      }
      this.inputData['new_route_list'] = new_route_list;
    }
    // this.inputData['adr_path'] = this.myAdrForm.value.ADRpath;
    // this.inputData['adr_file_name'] = this.file;

    // this.inputData['available_paths'] = this.inputData['available_paths'];
    this.apiService.onadrcallN2P(this.inputData).subscribe({
      next: (response) => {
        this.showADRCard = false;

        if (response.message.indexOf(
            "Tool generated path doesn't match with ADR"
          ) != -1
        ) {
          this.url = response.url;
          this.filename = response.file_name;
          this.msg = response.message;
          this.showMessage = true;
          this.MessageToShow = JSON.stringify(response);
        } else if (response.message == 'Pre-signed url has been generated') {
          this.url = response.url;
          this.filename = response.file_name;
          this.msg = response.message;
          this.showMessage = true;
          this.MessageToShow = JSON.stringify(response);
        }
        else {
          this.url = response.url;
          this.filename = response.file_name;
          this.msg = response.message;
          this.showMessage = true;
          this.MessageToShow = JSON.stringify(response);
        }
        this.isLoading = false;
        this.spinner.hide();
        // window.alert(response.messgae);
      },
      error: (error) => {
        this.isLoading = false;
        this.spinner.hide();
        this.toastr.error(
          `The API returned Unsuccessfull response : ${error}`,
          'Error Message'
        );
        //window.alert(`The API returned Unsuccessfull response : ${error}`);
      },
    });
  }

  
}
